import { Action } from 'redux';

import { SetRootAdminUiState } from '../actions/AppActionTypes';
import { isActionFactory } from '../actions/isActionFactory';
import { RootAdminUiState } from './RootAdminUIState';

export interface SetRootAdminUiStateAction extends Action {
  rootAdminUiState: RootAdminUiState;
}

export function setRootAdminUiState(rootAdminUiState: RootAdminUiState): SetRootAdminUiStateAction {
  return {
    type: SetRootAdminUiState,
    rootAdminUiState
  };
}

export const isSetRootAdminUiStateAction = isActionFactory<SetRootAdminUiStateAction>(SetRootAdminUiState);
